// Mistura o áudio dos dois lados (esquerdo = vendedor, direito = cliente) em PCM 16 kHz
// e manda em blocos de 100 ms pro voz/, que devolve transcrição e cards.
import { useWhatsappCallsStore } from 'dashboard/stores/whatsappCalls';

const WORKLET = `
class PcmProcessor extends AudioWorkletProcessor {
  constructor() { super(); this.chunks = []; this.frames = 0; }
  process(inputs) {
    const input = inputs[0];
    if (!input || input.length < 2) return true;
    const l = input[0], r = input[1];
    const frame = new Int16Array(l.length * 2);
    for (let i = 0; i < l.length; i += 1) {
      frame[2 * i] = Math.max(-1, Math.min(1, l[i])) * 0x7fff;
      frame[2 * i + 1] = Math.max(-1, Math.min(1, r[i])) * 0x7fff;
    }
    this.chunks.push(frame);
    this.frames += l.length;
    if (this.frames >= 1600) {
      const out = new Int16Array(this.frames * 2);
      let offset = 0;
      for (const c of this.chunks) { out.set(c, offset); offset += c.length; }
      this.port.postMessage(out.buffer, [out.buffer]);
      this.chunks = []; this.frames = 0;
    }
    return true;
  }
}
registerProcessor('pcm-processor', PcmProcessor);
`;

export function vozWsUrl(token) {
  const base = window.chatwootConfig?.vozUrl || '/voz';
  const root = base.startsWith('/')
    ? `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}${base}`
    : base.replace(/^http/, 'ws');
  return `${root}/ws?token=${encodeURIComponent(token)}`;
}

export async function startCopilot({ token, localStream, remoteStream }) {
  const store = useWhatsappCallsStore();
  const ctx = new AudioContext({ sampleRate: 16000 });
  let node;
  try {
    await ctx.audioWorklet.addModule(
      URL.createObjectURL(
        new Blob([WORKLET], { type: 'application/javascript' })
      )
    );
    const merger = ctx.createChannelMerger(2);
    ctx.createMediaStreamSource(localStream).connect(merger, 0, 0);
    ctx.createMediaStreamSource(remoteStream).connect(merger, 0, 1);
    node = new AudioWorkletNode(ctx, 'pcm-processor', {
      channelCount: 2,
      channelCountMode: 'explicit',
      channelInterpretation: 'discrete',
    });
    merger.connect(node);
    node.connect(ctx.destination);
  } catch (error) {
    ctx.close().catch(() => {});
    throw error;
  }

  const ws = new WebSocket(vozWsUrl(token));
  ws.binaryType = 'arraybuffer';
  store.setCopilotStatus('connecting');
  node.port.onmessage = e => {
    if (ws.readyState === WebSocket.OPEN) ws.send(e.data);
  };
  ws.onmessage = e => {
    const msg = JSON.parse(e.data);
    if (msg.type === 'transcript') store.addTranscript(msg.item);
    if (msg.type === 'insight') store.addInsight(msg.card);
    if (msg.type === 'status') store.setCopilotStatus(msg.copilot);
  };
  ws.onerror = () => store.setCopilotStatus('unavailable');
  ws.onclose = () => {
    if (store.copilotStatus !== 'unavailable') store.setCopilotStatus('idle');
  };

  return {
    stop() {
      node.port.onmessage = null;
      if (ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({ type: 'end' }));
        setTimeout(() => ws.close(), 500);
      } else if (ws.readyState === WebSocket.CONNECTING) {
        ws.close();
      }
      ctx.close().catch(() => {});
    },
  };
}
